import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ApiError } from './lib/api';
import { sessionKey } from './lib/session';
import { adminSessionKey } from './lib/admin';
import { router } from './router';
import './styles.css';

const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

// If any request finds the session has ended, go back to signed-out.
queryClient.getQueryCache().subscribe((e) => {
  const err = e.query.state.error;
  if (e.type !== 'updated' || !(err instanceof ApiError) || err.status !== 401) return;
  const [first, second] = e.query.queryKey;
  // The admin console has its own session, separate from coach sign-in.
  if (first === 'admin') {
    if (second !== 'session') void queryClient.invalidateQueries({ queryKey: adminSessionKey });
  } else if (first !== 'session') {
    void queryClient.invalidateQueries({ queryKey: sessionKey });
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
